export default __webpack_public_path__ + "static/media/mbt-speed.94dd7c92.svg";